<template>
  <right-banner-template :title="title">
    <div class="site-map">
      <ul>
        <li id="biga"><router-link to="/">{{ home }}</router-link>
          <span><img @contextmenu.prevent src="../../assets/treeGoc.gif"></span>
        </li>
        <li v-for="(menu,index) in menus" :key="index" id="biga">
          <span><img @contextmenu.prevent src="../../assets/treeGoc.gif"></span>
          <router-link :to="menu.url + context(menu.id)">{{ menu.name }}</router-link>
          <ul>
            <li v-for="(subMenu, subIndex) in subMenu(menu.id)" :key="subIndex" id="bolda">
              <router-link :to="subMenu.url">{{ subMenu.name }}</router-link>
              <ul>
                <li v-for="(subMenu1, subIndex1) in serviceMenu(subMenu.id)" :key="subIndex1" id="normala">
                  <router-link :to="{ name: subMenu1.routeName, params: { url: subMenu1.url } }">{{ subMenu1.name }}</router-link>
                  <ul>
                    <li v-for="(subMenu2, subIndex2) in serviceMenuDetails(subMenu1.id)" :key="subIndex2" id="normala">
                      <router-link :to="{ name: subMenu2.routeName, params: { url: subMenu2.url } }">{{ subMenu2.name }}</router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <!-- <div class="site-map">
      <ul>
        <li v-for="(menu, index) in $store.getters['web/finalMenus']" :key="index" id="biga">
          <router-link :to="menu.url">{{ menu.name }}</router-link>
          <ul>
            <li v-for="(subMenu, subIndex) in menu.subMenus" :key="subIndex" id="bolda">
              <router-link :to="subMenu.url">{{ subMenu.name }}</router-link>
              <ul>
                <li v-for="(subMenu1, subIndex1) in subMenu.subMenus1" :key="subIndex1" id="normala">
                  <router-link :to="subMenu1.url">{{ subMenu1.name }}</router-link>
                  <ul>
                    <li v-for="(subMenu2, subIndex2) in subMenu1.subMenus2" :key="subIndex2" id="normala">
                      <router-link :to="subMenu2.url">{{ subMenu2.name }}</router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div> -->
  </right-banner-template>
</template>

<script>
export default {
  props: ['title'],
  computed: {
    home () {
      return this.$store.getters['home/finalHomeTitle']
    },
    menus () {
      return this.$store.getters['navbar/finalMenu']
    }
  },
  methods: {
    context (id) {
      if (id === 1 || id === 8) return '/history-foundation'
      else if (id === 3 || id === 10) return '/pilot-training'
      else if (id === 4 || id === 11) return '/training-devices'
      else if (id === 5 || id === 12) return '/student-pilot'
      else if (id === 6 || id === 13) return '/library'
      else return ''
    },
    subMenu (id) {
      return this.$store.getters['navbar/finalSubMenus1'](id)
    },
    serviceMenu (id) {
      return this.$store.getters['services/filterSubMenus2'](id)
    },
    serviceMenuDetails (id) {
      return this.$store.getters['services/filterSubMenus3'](id)
    }
  }
}
</script>

<style scoped>
.site-map { padding-left: 25px;
  }

  ul {
    list-style: none;
  }

  ul li {
    margin: 6px 0px;
  }

  ul span {
    position: absolute;
    left: 0px;
    top: 6.5px;
    z-index: 2;
  }

  ul #biga {
    padding-left: 30px;
    position: relative;
    /* background-image: url(../../assets/treeGoc.gif);
    background-repeat: no-repeat;
    font-weight: bold;
    text-transform: uppercase;
    background-position-y: 7px;
    background-position: left center; */
  }

  ul li a{
    color: rgb(28, 108, 193);
    text-decoration: none;
    font-weight: bold;
    font-size: 22px;
  }

  ul {
    position: relative;
  }

  ul li::before {
    content: '';
    position: absolute;
    top: 0;
    left: 6.5px;
    height: 100%;
    border-left: 2px dashed #ababab;
    z-index: 1;
  }

  ul li ul li {
    padding-left: 30px;
  }

  ul li a:hover{
    color: #DBA30D;
  }

  ul li ul li a{
    color: black;
    text-decoration: none;
    font-weight: bold;
    font-size: 16px;
  }

  ul li ul li ul li a{
    color: black;
    text-decoration: none;
    font-weight: normal;
    font-size: 16px;
  }

  #bolda {
    font-weight: bold;
    text-transform: none;
  }

  #normala {
    text-transform: none;
    font-weight: bold;
  }

  @media (max-width: 720px) {
    ul li a{
      font-size: 18px;
    }

    ul li ul li a{
      font-size: 16px;
    }

    ul li ul li ul li a{
      font-size: 14px;
    }
  }
</style>
